<div class="modal-header">
  <h5 class="modal-title" id="newGroupLabel" i18n="@@CreateNewGroupHeader">Neue Gruppe erstellen</h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
    (click)="onCancelClick()"></button>
</div>

<div class="modal-body">
  <div class="container">
    <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)" *ngIf="formCreated">
      <div class="form-group row">
        <label class="nested required" i18n="@@GroupNameLabel">Gruppenname*</label>
        <input id="input_groupname" type="text" formControlName="name" class="form-control"
          i18n-placeholder="@@NameOfChargingGroupPlaceholder" placeholder="Gruppenname*" required />

        <div class="error">
          <em *ngIf="formService.validateControl('name') && formService.hasError('name', 'required')"
            i18n="@@GroupNameRequiredErrorMessage">
            Gruppenname wird benötigt
          </em>
        </div>
      </div>

      <div class="form-group row">
        <label class="nested" i18n="@@DescriptionLabel">Beschreibung (optional)</label>
        <textarea id="input_groupdescription" formControlName="description" rows="3" class="form-control"
          i18n-placeholder="@@OptionalDescriptionPlaceholder" placeholder="Beschreibung (optional)"></textarea>
      </div>

      <div class="row assignment-columns">
        <div class="col-md-6 assignment-column">
          <label for="chargingstations" class="form-label persistent" i18n="@@ChargingstationsLabel">Ladestationen</label>
          <ng-select id="chargingstations" class="group-assignment-select group-assignment-select--picker" [appendTo]="'body'"
            [items]="chargingstations" bindLabel="name" formControlName="selectedChargingstations" multiple="true"
            [closeOnSelect]="false" [clearSearchOnAdd]="true" [hideSelected]="true"
            i18n-notFoundText="@@NoEntriesAvailable" notFoundText="Keine Einträge vorhanden"
            placeholder="Ladestationen zuordnen" i18n-placeholder="@@ChooseChargingsations">
          </ng-select>
          <div class="assigned-items-list" aria-label="Zugeordnete Ladestationen">
            <div *ngFor="let station of selectedChargingStations; trackBy: trackChargingStationById"
              class="assigned-items-list__item">
              <span class="assigned-items-list__label">{{ station.name }}</span>
              <button type="button" class="assigned-items-list__remove" (click)="clearChargingStation(station)"
                aria-label="Ladestation entfernen">×</button>
            </div>
            <div *ngIf="selectedChargingStations.length === 0" class="assigned-items-list__empty">
              Keine Ladestationen zugeordnet
            </div>
          </div>
        </div>

        <div class="col-md-6 assignment-column">
          <label for="users" class="form-label persistent" i18n="@@UsersLabel">Benutzer</label>
          <ng-select id="users" class="group-assignment-select group-assignment-select--picker" [appendTo]="'body'"
            [items]="users" bindLabel="fullName" formControlName="selectedUsers" multiple="true" [closeOnSelect]="false"
            [clearSearchOnAdd]="true" [hideSelected]="true" placeholder="Benutzer zuordnen" i18n-placeholder="@@ChooseUsers"
            [compareWith]="compareUsersById" [searchFn]="userMultiSelectSearchFn"
            i18n-notFoundText="@@NoEntriesAvailable" notFoundText="Keine Einträge vorhanden">
            <ng-template ng-option-tmp let-item="item">
              <span class="px-2">{{ item.fullName + ' (' + item.email + ')' }}</span>
            </ng-template>
          </ng-select>
          <div class="assigned-items-list" aria-label="Zugeordnete Benutzer">
            <div *ngFor="let user of selectedUsers; trackBy: trackUserById" class="assigned-items-list__item">
              <span class="assigned-items-list__label">{{ getUserDisplayName(user) }}</span>
              <button type="button" class="assigned-items-list__remove" (click)="clearUser(user)"
                aria-label="Benutzer entfernen">×</button>
            </div>
            <div *ngIf="selectedUsers.length === 0" class="assigned-items-list__empty">
              Keine Benutzer zugeordnet
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" id="cancel" class="btn btn-yellow d-inline me-1" data-bs-dismiss="modal"
    (click)="onCancelClick()" i18n="@@CancelButton">Schließen</button>
  <button type="submit" id="save" class="btn btn-save" (click)="onSubmit(formService.form.value)"
     i18n="@@SaveButton" [disabled]="formService.form?.invalid || !formService.form?.dirty">Änderungen speichern</button>
</div>
